import React from 'react';
import styled from 'styled-components';
import closeAsset from '../../assets/close.svg';
import Lightbox from '../lightbox/Lightbox';
import { ReferenceToElement } from '../accessibility';

// tslint:disable-next-line:variable-name
const SPopup = styled.section<{ customHeight?: string }>(
  ({ theme, customHeight }) => `
  position: relative;
  background-color: ${theme.colors.white};
  box-shadow: 0 0 28px 16px rgba(0, 0, 0, 0.12);
  margin: 20px;
  box-sizing: border-box;
  padding: ${theme.spacing.larger}px;

  &:focus { outline: 0px transparent }

  @media only screen and ${theme.device.laptopS} {
    padding: 50px;
    width: 750px;
    box-sizing: border-box;
    ${customHeight ? `height: ${customHeight}` : ''}
  }
`,
);

// tslint:disable-next-line:variable-name
const SCloseButton = styled.button`
  border: none;
  cursor: pointer;
  background: transparent url(${closeAsset}) no-repeat;
  background-size: 24px 24px;
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 1;
  top: 13px;
  left: 15px;

  &:hover {
    opacity: 0.5;
  }
`;

export interface IPopup {
  className?: string;
  customHeight?: string;
  onClose?: () => void;
}

const Popup: React.FC<IPopup> = ({
                 customHeight,
                 className,
                 onClose,
                 children
               }) => {
  const popupContainer = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    popupContainer?.current?.focus();
  }, []);

  const handleClose = React.useCallback(() => {
    onClose?.();
  }, [onClose]);

  return (
    <Lightbox>
      <SPopup {...{ className, id: 'dialogModalElement', tabIndex: 0, ref: popupContainer, customHeight }} >
        {!!onClose && <SCloseButton aria-label="close pop-up" onClick={handleClose}/>}
        {children}
        <ReferenceToElement querySelector="#dialogModalElement"/>
      </SPopup>
    </Lightbox>
  );
};

export default Popup;
